export default __webpack_public_path__ + "static/media/deezer.db6d274c.svg";